<template>
  <div :class="classname">
   
    <div :class="classname" class="ding0" style="width: 100%;text-align:center;color:#000">
      {{ label }}
    </div>

    <select :class="classname"
      class="selectv  ding0"
      style="width: 100%"
      v-model="couponSelected"
      @change="getCouponSelected"
    >
      <option   v-for="(coupon, i) in couponList" :key="i" :value="coupon.id" >{{ coupon.name }}</option>
     
    </select>
       <input
        type="hidden"
        class="selectvalue biaodanziduan"
        :ziduanname="ziduanname"
        :requiretip="requiretip"
        :value="couponSelected"
      />
  </div>
</template>
<script>
// function getoptionlist() {
//   let optionlist = [];
//   let obj = {};
//   obj["id"] = "";
//   obj["name"] = "请选择";
//   optionlist.push(obj);
//   for (let i = 4; i <= 14; i++) {
//     let obj = {};
//     obj["id"] = i;
//     obj["name"] = i + "岁";
//     optionlist.push(obj);
//   }
//   return optionlist;
// }
//   <selects classname="p4_1_selectage" :couponList="couponList" requiretip="请输入年龄"></selects>
import { mapState} from "vuex";
export default {
  name: "selects",
  props: ["couponList","classname","requiretip","ziduanname"],
  data() {
    return {
      label: "",
      couponSelected: "",
    };
  },
  created() {},
  mounted() {},

  methods: {
    getCouponSelected() {
      let obj = this.couponList.find((item) => {
        return item.id === this.couponSelected;
      });
      this.label=obj.name;
    },
  },
  computed: {
    ...mapState([
      "suodingtipcss",
      "yujiazaicss",
      "sharetipcontainercss",
      "morentanchuangcss",
      "chuangtitle",
      "fn",
      "jindu",
      "starcss",
      "isalljiazai",
      "isplaybgmusic",
    ]),
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/selects.vue